import React, { useEffect, useState } from 'react';
import { IdRegistration, Installation, Status } from 'src/common/types';

export interface ProcessProps {
  registration: IdRegistration;
  updateRegistration: (name: string, value: string | number) => void;
}

export const ProcessComponent = ({ registration, updateRegistration }: ProcessProps) => {
  const [localProcess, setLocalProcess] = useState<string>('');
  const [classname, setClassname] = useState<string>('error');

  useEffect(() => {
    if (localProcess !== '') {
      updateRegistration('process', isCorrect() ? localProcess : '');
    }
  }, [localProcess, updateRegistration]);

  const isCorrect = () => {
    return localProcess.length === 5;
  };

  useEffect(() => {
    if (registration.process === '' && isCorrect()) {
      setLocalProcess(registration.process);
    }
  }, [registration.process]);

  useEffect(() => {
    if (registration.installation === Installation.NAREGELING && registration.process === '') {
      setClassname('error');
    } else {
      setClassname('');
    }
  }, [registration.installation, registration.process]);

  return (
    <>
      {registration.status !== Status.MIGRATED ? (
        <div className="property">
          <label>Proces</label>
          <input
            data-testid="process"
            className={classname}
            name="process"
            value={localProcess === '' || !localProcess ? registration.process : localProcess}
            onChange={event => setLocalProcess(event.target.value)}
            placeholder="Processcode 5 karakters"
          />
        </div>
      ) : null}
    </>
  );
};
